module.exports = __webpack_public_path__ + "static/img/paypal-3.c15b114.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/help/paypal-3.png
// module id = NAl4
// module chunks = 1